import ReportingPerformanceViews from '../Views/ReportingPerformanceViews';

export default function ReportingPerformanceOverviewTab() {
    return <ReportingPerformanceViews heading={undefined} />;
}
